import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { bedrijf } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-stone-950 text-stone-300 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <h3 className="font-heading text-2xl font-semibold text-stone-100 mb-3">De Proatkoele</h3>
          <p className="text-stone-100/70 leading-relaxed max-w-xs">
            Sfeervol partycenter in Dedemsvaart voor feesten, groepen en bijeenkomsten.
          </p>
        </div>

        <div className="space-y-3">
          <h4 className="font-heading text-lg text-stone-100 mb-1">Contact</h4>
          <a href={bedrijf.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-stone-100/80 hover:text-stone-100 transition-colors">
            <MapPin size={18} className="mt-0.5 shrink-0" />
            <span>{bedrijf.adres}, {bedrijf.postcode}</span>
          </a>
          <a data-testid="footer-phone" href={`tel:${bedrijf.telefoonRaw}`} className="flex items-center gap-3 text-stone-100/80 hover:text-stone-100 transition-colors">
            <Phone size={18} /> {bedrijf.telefoon}
          </a>
          <a href={`mailto:${bedrijf.email}`} className="flex items-center gap-3 text-stone-100/80 hover:text-stone-100 transition-colors break-all">
            <Mail size={18} /> {bedrijf.email}
          </a>
        </div>

        <div className="space-y-3">
          <h4 className="font-heading text-lg text-stone-100 mb-1">Volg ons</h4>
          <div className="flex gap-3">
            <a data-testid="footer-facebook" href={bedrijf.facebook} target="_blank" rel="noopener noreferrer" className="p-2.5 rounded-full bg-white/10 hover:bg-primary transition-colors" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a data-testid="footer-instagram" href={bedrijf.instagram} target="_blank" rel="noopener noreferrer" className="p-2.5 rounded-full bg-white/10 hover:bg-primary transition-colors" aria-label="Instagram">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-background/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-sm text-stone-100/60 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Partycenter De Proatkoele, Dedemsvaart</span>
          <a href="/admin" className="hover:text-stone-100/90 transition-colors">Beheer</a>
        </div>
      </div>
    </footer>
  );
};
